import script from "./LevelChart.vue?vue&type=script&setup=true&lang=js"
export * from "./LevelChart.vue?vue&type=script&setup=true&lang=js"

import "./LevelChart.vue?vue&type=style&index=0&id=4e2de54a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e2de54a"]])

export default __exports__